import React from 'react'
import styled from 'styled-components'

let Page = styled.div`
  padding: 20px 40px;
  max-width: 1600px;
  min-height: 90vh;
  @media (min-width: 576px) {
    padding: 20px 60px;
  }

  @media (min-width: 768px) {
    padding: 20px 70px;
  }

  @media (min-width: 992px) {
    padding: 20px 80px;
  }

  @media (min-width: 1200px) {
    padding: 20px 100px;
  }
`

const PageContainer = (props) => {
  return <Page className="container-fluid">{props.children}</Page>
}

export default PageContainer
